import React, { useEffect, useRef } from "react";

export function Reveal({ children, delay = 0, as: Tag = "div", className = "" }) {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => el.classList.add("is-visible"), delay);
                        io.unobserve(el);
                    }
                });
            },
            { threshold: 0.12 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [delay]);
    return (
        <Tag ref={ref} className={`reveal ${className}`}>
            {children}
        </Tag>
    );
}
